(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    // AuroKids wishlist — frontend only, no app required.
  // Toggles a filled heart and persists the wishlist in localStorage.
  (function () {
    if (window.__akWishlistInit) return;
    window.__akWishlistInit = true;

    var STORAGE_KEY = 'aurokids_wishlist';

    function readWishlist() {
      try {
        var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        return Array.isArray(list) ? list.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    function writeWishlist(list) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (error) {
        // Private browsing etc. — the wishlist simply won't persist.
      }
    }

    function syncButtons() {
      var saved = readWishlist();
      document.querySelectorAll('[data-ak-wishlist]').forEach(function (button) {
        var active = saved.indexOf(String(button.getAttribute('data-ak-wishlist'))) !== -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // Event delegation: also covers cards added later (filters, AJAX).
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ak-wishlist]');
      if (!button) return;
      // Don't follow the card link when the heart is clicked.
      event.preventDefault();
      event.stopPropagation();
      var id = String(button.getAttribute('data-ak-wishlist'));
      var saved = readWishlist();
      var index = saved.indexOf(id);
      if (index === -1) {
        saved.push(id);
      } else {
        saved.splice(index, 1);
      }
      writeWishlist(saved);
      syncButtons();
    });

    function init() {
      syncButtons();
      // Re-sync when cards are re-rendered (e.g. collection filtering).
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-ak-wishlist]')) {
                syncButtons();
                return;
              }
            }
          }
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-card"] && !Shopify.designMode) return;
  try {
    // AuroKids wishlist — frontend only, no app required.
  // Toggles a filled heart and persists the wishlist in localStorage.
  (function () {
    if (window.__akWishlistInit) return;
    window.__akWishlistInit = true;

    var STORAGE_KEY = 'aurokids_wishlist';

    function readWishlist() {
      try {
        var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        return Array.isArray(list) ? list.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    function writeWishlist(list) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (error) {
        // Private browsing etc. — the wishlist simply won't persist.
      }
    }

    function syncButtons() {
      var saved = readWishlist();
      document.querySelectorAll('[data-ak-wishlist]').forEach(function (button) {
        var active = saved.indexOf(String(button.getAttribute('data-ak-wishlist'))) !== -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // Event delegation: also covers cards added later (filters, AJAX).
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ak-wishlist]');
      if (!button) return;
      // Don't follow the card link when the heart is clicked.
      event.preventDefault();
      event.stopPropagation();
      var id = String(button.getAttribute('data-ak-wishlist'));
      var saved = readWishlist();
      var index = saved.indexOf(id);
      if (index === -1) {
        saved.push(id);
      } else {
        saved.splice(index, 1);
      }
      writeWishlist(saved);
      syncButtons();
    });

    function init() {
      syncButtons();
      // Re-sync when cards are re-rendered (e.g. collection filtering).
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-ak-wishlist]')) {
                syncButtons();
                return;
              }
            }
          }
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
